"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4291],{

/***/ 24497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jk": function() { return /* binding */ AvailableFunds; }
/* harmony export */ });
/* unused harmony exports GetFundsDetails, GetFundsModal, GetFundsButton */
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(16835);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3712);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16610);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59099);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15715);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32761);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50232);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(54506);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(38488);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5490);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(89865);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26840);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(57391);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(21360);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(70010);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(73636);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(90092);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(83658);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(26972);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(48899);
/* harmony import */ var _hooks_useBalance__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32596);
/* harmony import */ var _hooks_useFiatPrice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25634);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(82580);
/* harmony import */ var _helpers_createStrategyFeeInTokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18081);
/* harmony import */ var _components_OnRampModalContent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21151);
/* harmony import */ var _components_SquidModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62170);
/* harmony import */ var _hooks_useChainContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16664);
/* harmony import */ var _utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11599);
/* harmony import */ var _hooks_useQueryState__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9397);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);














function GetFundsDetails(_ref) {
  var onSquidOpen = _ref.onSquidOpen,
      onOnRampOpen = _ref.onOnRampOpen;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Stack */ .K, {
    direction: {
      base: 'column',
      sm: 'row'
    },
    spacing: 4,
    px: 8,
    py: 4,
    bg: "abyss.200",
    fontSize: "sm",
    borderRadius: "xl",
    borderWidth: 1,
    borderColor: "slateGrey",
    w: "full",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Grid */ .r, {
      templateColumns: "repeat(1, 1fr)",
      textAlign: "center",
      px: 2,
      w: {
        base: 'full',
        sm: 56
      },
      gap: 4,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .GridItem */ .P, {
        h: 6,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Center */ .M, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Image */ .E, {
            src: "/images/squid-icon-logo-yellow.svg",
            alt: "squid-logo",
            h: 6
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .GridItem */ .P, {
        h: {
          base: 8,
          sm: 12
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Heading */ .X, {
          size: "xs",
          children: "Squid Cross Chain Bridge"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .FormHelperText */ .Q6, {
          children: "Good for getting assets from other chains here."
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .GridItem */ .P, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__/* .Button */ .z, {
          w: 40,
          onClick: onSquidOpen,
          children: "Move assets here"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Grid */ .r, {
      templateColumns: "repeat(1, 1fr)",
      textAlign: "center",
      px: 2,
      w: {
        base: 'full',
        sm: 56
      },
      gap: 4,
      pt: {
        base: 4,
        sm: 'initial'
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .GridItem */ .P, {
        h: 6,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Center */ .M, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Image */ .E, {
            src: "/images/kado-no-padding.png",
            alt: "kado-logo",
            h: 6
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .GridItem */ .P, {
        h: {
          base: 8,
          sm: 12
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Heading */ .X, {
          size: "xs",
          children: "Buy Crypto"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .FormHelperText */ .Q6, {
          children: "Good for getting crypto with cash."
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .GridItem */ .P, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__/* .Button */ .z, {
          w: 40,
          onClick: onOnRampOpen,
          children: "Buy crypto"
        })
      })]
    })]
  });
}
function GetFundsModal(_ref2) {
  var onSquidOpen = _ref2.onSquidOpen,
      onOnRampOpen = _ref2.onOnRampOpen,
      isOpen = _ref2.isOpen,
      onClose = _ref2.onClose;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Modal */ .u_, {
    isOpen: isOpen,
    onClose: onClose,
    size: "xl",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .ModalOverlay */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .ModalContent */ .h, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .ModalHeader */ .x, {
        children: "Get Funds"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .ModalCloseButton */ .o, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_22__/* .ModalBody */ .f, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Stack */ .K, {
          justify: "center",
          gap: 6,
          align: "center",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(GetFundsDetails, {
            onSquidOpen: onSquidOpen,
            onOnRampOpen: onOnRampOpen
          })
        })
      })]
    })]
  });
}
function GetFundsButton(_ref3) {
  var onOpen = _ref3.onOpen;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_23__/* .HStack */ .U, {
    spacing: 1,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
      fontSize: "xs",
      children: "None"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__/* .Button */ .z, {
      size: "xs",
      "data-testid": "get-funds-button",
      colorScheme: "blue",
      variant: "link",
      cursor: "pointer",
      onClick: onOpen,
      children: "Get funds"
    })]
  });
}

function AvailableFundsButton(_ref4) {
  var denom = _ref4.denom,
      isLoading = _ref4.isLoading,
      data = _ref4.data;

  var _useDisclosure = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_25__/* .useDisclosure */ .q)(),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var _useDisclosure2 = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_25__/* .useDisclosure */ .q)(),
      isOnRampOpen = _useDisclosure2.isOpen,
      onOnRampClose = _useDisclosure2.onClose,
      onOnRampOpen = _useDisclosure2.onOpen;

  var _useDisclosure3 = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_25__/* .useDisclosure */ .q)(),
      isSquidOpen = _useDisclosure3.isOpen,
      onSquidClose = _useDisclosure3.onClose,
      onSquidOpen = _useDisclosure3.onOpen;

  var chainContext = (0,_hooks_useChainContext__WEBPACK_IMPORTED_MODULE_5__/* .useChainContext */ .q)();

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_26__/* .useField */ .U$)('initialDeposit'),
      _useField2 = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(_useField, 3),
      helpers = _useField2[2];

  var _useFiatPrice = (0,_hooks_useFiatPrice__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(denom),
      fiatPrice = _useFiatPrice.fiatPrice;

  var _useQueryState = (0,_hooks_useQueryState__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
      _useQueryState2 = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(_useQueryState, 2),
      setQueryState = _useQueryState2[1];

  var createStrategyFee = fiatPrice ? (0,_helpers_createStrategyFeeInTokens__WEBPACK_IMPORTED_MODULE_2__/* .createStrategyFeeInTokens */ .y)(fiatPrice, denom) : 0;
  var balance = Number(data === null || data === void 0 ? void 0 : data.amount);
  var displayAmount = (0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_6__/* .fromAtomic */ .b1)(denom, Math.max(balance - createStrategyFee, 0));
  var displayFee = (0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_6__/* .fromAtomic */ .b1)(denom, createStrategyFee);

  function handleOpen(onOpener) {
    return function () {
      onClose();
      onOpener();
    };
  }

  if (displayAmount) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_28__/* .Tooltip */ .u, {
        isDisabled: balance === 0,
        label: "This is the estimated balance available to you after fees have been deducted ( ".concat(String.fromCharCode(8275), " ").concat(displayFee, " ").concat(denom.name, "). This excludes gas fees, so please make sure you have remaining funds."),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_24__/* .Text */ .x, {
          mr: 1,
          children: "Available: "
        })
      }), isLoading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_29__/* .Spinner */ .$, {
        size: "xs"
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__/* .Button */ .z, {
        size: "xs",
        isLoading: isLoading,
        colorScheme: "blue",
        variant: "link",
        cursor: "pointer",
        isDisabled: !displayAmount,
        onClick: function onClick() {
          setQueryState({
            amount: (0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_6__/* .toAtomic */ .Iy)(denom, displayAmount)
          });
          helpers.setValue((0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_6__/* .toAtomic */ .Iy)(denom, displayAmount));
          helpers.setTouched(true);
        },
        children: displayAmount
      })]
    });
  }

  if (chainContext !== null && chainContext !== void 0 && chainContext.isWalletConnected) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(GetFundsButton, {
        onOpen: onOpen
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(GetFundsModal, {
        isOpen: isOpen,
        onClose: onClose,
        onSquidOpen: handleOpen(onSquidOpen),
        onOnRampOpen: handleOpen(onOnRampOpen)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_SquidModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isOpen: isSquidOpen,
        onClose: onSquidClose
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_OnRampModalContent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isOpen: isOnRampOpen,
        onClose: onOnRampClose
      })]
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__/* .Button */ .z, {
    size: "xs",
    colorScheme: "blue",
    variant: "link",
    cursor: "pointer",
    onClick: chainContext === null || chainContext === void 0 ? void 0 : chainContext.openView,
    children: "Connect wallet"
  });
}

function AvailableFunds(_ref5) {
  var denom = _ref5.denom;

  var _useBalance = (0,_hooks_useBalance__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(denom),
      data = _useBalance.data,
      isLoading = _useBalance.isLoading;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Center */ .M, {
    textStyle: "body-xs",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(AvailableFundsButton, {
      isLoading: isLoading,
      data: data,
      denom: denom
    })
  });
}

/***/ }),

/***/ 47309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ConnectWalletButton; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38488);
/* harmony import */ var _hooks_useChainContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16664);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function ConnectWalletButton() {
  var chainContext = (0,_hooks_useChainContext__WEBPACK_IMPORTED_MODULE_0__/* .useChainContext */ .q)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
    onClick: chainContext === null || chainContext === void 0 ? void 0 : chainContext.openView,
    children: "Connect to a wallet"
  });
}

/***/ }),

/***/ 75872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ DenomSelect; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(27812);
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73636);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90092);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74032);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88329);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14114);
/* harmony import */ var _components_DenomIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32685);
/* harmony import */ var chakra_react_select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70818);
/* harmony import */ var _hooks_useBalances__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52560);
/* harmony import */ var _hooks_useFiatPrices__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54456);
/* harmony import */ var _hooks_useChainId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12680);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _Select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44328);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);



var _excluded = ["isSelected", "rightLabel", "children"],
    _excluded2 = ["children", "isSelected"],
    _excluded3 = ["denoms", "optionLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












function formatBalance(balance) {
  if (balance > 0 && balance < 0.000001) return '<0.000001';
  return balance.toLocaleString('en-US', {
    maximumFractionDigits: 6
  });
}

function DenomSelectLabel(_ref) {
  var denom = _ref.denom,
      balance = _ref.balance;
  var name = denom.name;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .HStack */ .U, {
    flexGrow: 1,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_DenomIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      denomInfo: denom
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
      children: name
    }), balance > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Badge */ .C, {
      colorScheme: "blue",
      textTransform: "none",
      variant: "subtle",
      children: formatBalance(balance)
    })]
  });
}

function DenomOption(_ref2) {
  var isSelected = _ref2.isSelected,
      rightLabel = _ref2.rightLabel,
      children = _ref2.children,
      optionProps = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_ref2, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chakra_react_select__WEBPACK_IMPORTED_MODULE_2__/* .chakraComponents.Option */ .sC.Option, _objectSpread(_objectSpread({
    isSelected: isSelected
  }, optionProps), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Flex */ .k, {
      alignItems: "center",
      w: "full",
      children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Spacer */ .L, {}), rightLabel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
        fontSize: "xs",
        children: rightLabel
      })]
    })
  }));
}

function getDenomOptionComponent(rightLabel) {
  // eslint-disable-next-line func-names
  return function (_ref3) {
    var childrenProp = _ref3.children,
        isSelected = _ref3.isSelected,
        props = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_ref3, _excluded2);

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(DenomOption, _objectSpread(_objectSpread({
      isSelected: isSelected,
      rightLabel: rightLabel
    }, props), {}, {
      children: childrenProp
    }));
  };
}

function DenomSelect(_ref4) {
  var denoms = _ref4.denoms,
      optionLabel = _ref4.optionLabel,
      selectProps = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_ref4, _excluded3);

  var _useChainId = (0,_hooks_useChainId__WEBPACK_IMPORTED_MODULE_5__/* .useChainId */ .x)(),
      chainId = _useChainId.chainId;

  var _useBalances = (0,_hooks_useBalances__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      balances = _useBalances.balances;

  var balancesByDenom = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function () {
    var _balances$filter$map;

    return new Map((_balances$filter$map = balances === null || balances === void 0 ? void 0 : balances.filter(function (_ref5) {
      var amount = _ref5.amount;
      return Number(amount) > 0;
    }).map(function (_ref6) {
      var denom = _ref6.denom,
          amount = _ref6.amount;
      return [denom, amount];
    })) !== null && _balances$filter$map !== void 0 ? _balances$filter$map : []);
  }, [balances]);
  var balanceDenomIds = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function () {
    return Array.from(balancesByDenom.keys());
  }, [balancesByDenom]);

  var _useFiatPrices = (0,_hooks_useFiatPrices__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([chainId], balanceDenomIds),
      fiatPrices = _useFiatPrices.fiatPrices;

  var balanceDetailsByDenom = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function () {
    return new Map(denoms.map(function (denom) {
      var _balancesByDenom$get, _fiatPrices$denom$coi;

      var balance = Number((_balancesByDenom$get = balancesByDenom.get(denom.id)) !== null && _balancesByDenom$get !== void 0 ? _balancesByDenom$get : 0) / 10 ** denom.significantFigures;
      var price = denom.coingeckoId ? fiatPrices === null || fiatPrices === void 0 ? void 0 : (_fiatPrices$denom$coi = fiatPrices[denom.coingeckoId]) === null || _fiatPrices$denom$coi === void 0 ? void 0 : _fiatPrices$denom$coi.usd : undefined;
      return [denom.id, {
        balance: balance,
        usdValue: balance > 0 && typeof price === 'number' ? balance * price : undefined
      }];
    }));
  }, [balancesByDenom, denoms, fiatPrices]);
  var sortedDenoms = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function () {
    return (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(denoms).sort(function (a, b) {
      var _balanceDetailsByDeno, _balanceDetailsByDeno2;

      var _ref7 = (_balanceDetailsByDeno = balanceDetailsByDenom.get(a.id)) !== null && _balanceDetailsByDeno !== void 0 ? _balanceDetailsByDeno : {},
          _ref7$balance = _ref7.balance,
          aBalance = _ref7$balance === void 0 ? 0 : _ref7$balance,
          aUsdValue = _ref7.usdValue;

      var _ref8 = (_balanceDetailsByDeno2 = balanceDetailsByDenom.get(b.id)) !== null && _balanceDetailsByDeno2 !== void 0 ? _balanceDetailsByDeno2 : {},
          _ref8$balance = _ref8.balance,
          bBalance = _ref8$balance === void 0 ? 0 : _ref8$balance,
          bUsdValue = _ref8.usdValue;

      var aHasUsdValue = typeof aUsdValue === 'number';
      var bHasUsdValue = typeof bUsdValue === 'number';
      var aHasBalance = aBalance > 0;
      var bHasBalance = bBalance > 0;
      if (aHasUsdValue !== bHasUsdValue) return aHasUsdValue ? -1 : 1;
      if (aHasUsdValue && bHasUsdValue && aUsdValue !== bUsdValue) return bUsdValue - aUsdValue;
      if (aHasBalance !== bHasBalance) return aHasBalance ? -1 : 1;
      return a.name.localeCompare(b.name);
    });
  }, [balanceDetailsByDenom, denoms]);

  var customComponents = function customComponents() {
    return {
      Option: getDenomOptionComponent(optionLabel)
    };
  };

  var pairsOptions = sortedDenoms.map(function (denom) {
    var _balanceDetailsByDeno3, _balanceDetailsByDeno4;

    return {
      value: [denom.id, denom.name],
      label: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(DenomSelectLabel, {
        denom: denom,
        balance: (_balanceDetailsByDeno3 = (_balanceDetailsByDeno4 = balanceDetailsByDenom.get(denom.id)) === null || _balanceDetailsByDeno4 === void 0 ? void 0 : _balanceDetailsByDeno4.balance) !== null && _balanceDetailsByDeno3 !== void 0 ? _balanceDetailsByDeno3 : 0
      })
    };
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_7__/* .SelectDenomWithSearch */ .x, _objectSpread({
    isSearchable: true,
    options: pairsOptions,
    customComponents: customComponents()
  }, selectProps));
}

/***/ }),

/***/ 45435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InitialDeposit; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4730);
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16835);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54506);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54795);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82580);
/* harmony import */ var _components_NumberInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56524);
/* harmony import */ var _hooks_useQueryState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9397);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11599);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32354);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);



var _excluded = ["onChange", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










function InitialDeposit() {
  var _ref, _fromAtomic;

  var _useFormikContext = (0,formik__WEBPACK_IMPORTED_MODULE_6__/* .useFormikContext */ .u6)(),
      initialDenom = _useFormikContext.values.initialDenom;

  var _useQueryState = (0,_hooks_useQueryState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      _useQueryState2 = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_useQueryState, 2),
      amount = _useQueryState2[0].amount,
      setQueryState = _useQueryState2[1];

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_6__/* .useField */ .U$)({
    name: 'initialDeposit'
  }),
      _useField2 = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_useField, 3),
      _useField2$ = _useField2[0],
      onChange = _useField2$.onChange,
      value = _useField2$.value,
      field = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_useField2$, _excluded),
      meta = _useField2[1],
      helpers = _useField2[2];

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    helpers.setValue(amount);
  }, [amount]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .FormControl */ .NI, {
    isInvalid: Boolean(meta.touched && meta.error),
    isDisabled: !initialDenom,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_NumberInput__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({
      onChange: function onChange(newAmount) {
        setQueryState({
          amount: newAmount && initialDenom && (0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_4__/* .toAtomicSafe */ .H8)(initialDenom, newAmount).toString()
        });
      },
      textAlign: "right",
      placeholder: "Enter amount",
      value: (_ref = amount && initialDenom && Number((_fromAtomic = (0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_4__/* .fromAtomic */ .b1)(initialDenom, amount)) === null || _fromAtomic === void 0 ? void 0 : _fromAtomic.toFixed((0,rambda__WEBPACK_IMPORTED_MODULE_10__/* .max */ .F)(initialDenom.significantFigures, 6)))) !== null && _ref !== void 0 ? _ref : ''
    }, field)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .FormErrorMessage */ .J1, {
      children: meta.touched && meta.error
    })]
  });
}

/***/ }),

/***/ 56524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NumberInput; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82206);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57333);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["value", "onChange", "type", "defaultValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function NumberInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      type = _ref.type,
      defaultValue = _ref.defaultValue,
      props = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  var handleChange = function handleChange(values) {
    try {
      onChange(values.floatValue || null);
    } catch (error) {// swallow
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_3__/* .NumericFormat */ .h3, _objectSpread({
    customInput: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Input */ .I,
    allowNegative: false,
    onValueChange: handleChange,
    value: value,
    defaultValue: defaultValue,
    thousandSeparator: ","
  }, props));
}

/***/ }),

/***/ 44328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Select; },
/* harmony export */   "x": function() { return /* binding */ SelectDenomWithSearch; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16835);
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var chakra_react_select__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70818);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function Select(_ref) {
  var options = _ref.options,
      placeholder = _ref.placeholder,
      _onChange = _ref.onChange,
      value = _ref.value,
      customComponents = _ref.customComponents,
      menuPortalTarget = _ref.menuPortalTarget,
      _ref$isSearchable = _ref.isSearchable,
      isSearchable = _ref$isSearchable === void 0 ? true : _ref$isSearchable;
  var selectProps = (0,chakra_react_select__WEBPACK_IMPORTED_MODULE_1__/* .useChakraSelectProps */ .Do)({
    menuPortalTarget: menuPortalTarget,
    useBasicStyles: true,
    onChange: function onChange(option) {
      _onChange(option === null || option === void 0 ? void 0 : option.value);
    },
    options: options,
    placeholder: placeholder,
    isSearchable: isSearchable,
    value: options === null || options === void 0 ? void 0 : options.find(function (option) {
      return value === option.value || null;
    }),
    chakraStyles: {
      control: function control(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          isReadOnly: true,
          caretColor: 'transparent'
        });
      }
    },
    components: customComponents
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(chakra_react_select__WEBPACK_IMPORTED_MODULE_1__/* .Select */ .Ph, _objectSpread({}, selectProps));
}
function SelectDenomWithSearch(_ref2) {
  var options = _ref2.options,
      placeholder = _ref2.placeholder,
      _onChange2 = _ref2.onChange,
      value = _ref2.value,
      customComponents = _ref2.customComponents,
      menuPortalTarget = _ref2.menuPortalTarget,
      _ref2$isSearchable = _ref2.isSearchable,
      isSearchable = _ref2$isSearchable === void 0 ? true : _ref2$isSearchable;
  var selectProps = (0,chakra_react_select__WEBPACK_IMPORTED_MODULE_1__/* .useChakraSelectProps */ .Do)({
    menuPortalTarget: menuPortalTarget,
    useBasicStyles: true,
    onChange: function onChange(option) {
      var _ref3 = (option === null || option === void 0 ? void 0 : option.value) || [],
          _ref4 = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref3, 1),
          id = _ref4[0];

      _onChange2(id);
    },
    options: options,
    placeholder: placeholder,
    isSearchable: isSearchable,
    value: value ? options === null || options === void 0 ? void 0 : options.find(function (option) {
      var _ref5 = (option === null || option === void 0 ? void 0 : option.value) || [],
          _ref6 = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref5, 1),
          id = _ref6[0];

      return value === id || null;
    }) : null,
    chakraStyles: {
      control: function control(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          isReadOnly: true,
          caretColor: 'transparent'
        });
      }
    },
    components: customComponents
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(chakra_react_select__WEBPACK_IMPORTED_MODULE_1__/* .Select */ .Ph, _objectSpread({}, selectProps));
}

/***/ }),

/***/ 18081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ createStrategyFeeInTokens; }
/* harmony export */ });
/* harmony import */ var _utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11599);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18459);


function createStrategyFeeInTokens(price, denom) {
  return (0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_0__/* .toAtomic */ .Iy)(denom, src_constants__WEBPACK_IMPORTED_MODULE_1__/* .CREATE_VAULT_FEE */ .Wh / price);
}

/***/ }),

/***/ 32596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _hooks_useWallet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5403);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67848);
/* harmony import */ var _utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11599);
/* harmony import */ var _hooks_useChainId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12680);
/* harmony import */ var _hooks_useChainClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74371);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







function useBalance(denom) {
  var _useWallet = (0,_hooks_useWallet__WEBPACK_IMPORTED_MODULE_1__/* .useWallet */ .O)(),
      address = _useWallet.address;

  var _useChainId = (0,_hooks_useChainId__WEBPACK_IMPORTED_MODULE_3__/* .useChainId */ .x)(),
      chainId = _useChainId.chainId;

  var client = (0,_hooks_useChainClient__WEBPACK_IMPORTED_MODULE_4__/* .useChainClient */ .Y)(chainId);
  var result = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a)(['balance', chainId, address, denom.id], function () {
    return client.fetchTokenBalance(address, denom);
  }, {
    enabled: !!denom.id && !!address && !!chainId && !!client,
    meta: {
      errorMessage: 'Error fetching balance'
    }
  });
  return _objectSpread({
    displayAmount: result.data ? (0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_2__/* .fromAtomic */ .b1)(denom, Number(result.data.amount)) : 0
  }, result);
}

/* harmony default export */ __webpack_exports__["Z"] = (useBalance);

/***/ }),

/***/ 5380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ usePairs; },
/* harmony export */   "jS": function() { return /* binding */ getResultingDenoms; },
/* harmony export */   "t1": function() { return /* binding */ orderAlphabetically; },
/* harmony export */   "wk": function() { return /* binding */ isSupportedDenomForDcaPlus; }
/* harmony export */ });
/* unused harmony exports uniqueQuoteDenoms, uniqueBaseDenoms, uniqueBaseDenomsFromQuoteDenom, uniqueQuoteDenomsFromBaseDenom, allDenomsFromPairs */
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4730);
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27812);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52680);
/* harmony import */ var _utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11599);
/* harmony import */ var _helpers_chains__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87038);
/* harmony import */ var _utils_pair__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17987);
/* harmony import */ var _hooks_useChainId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12680);
/* harmony import */ var _hooks_useCosmWasmClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32178);
/* harmony import */ var _hooks_useDenoms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(466);
/* harmony import */ var _hooks_useChainClient__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74371);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67848);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);



var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var hiddenPairs = [JSON.stringify(['ibc/D36D2BBE441D3605EEF340EAFAC57D669880597073050A2650B1468F1634A5F5', 'factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk']), JSON.stringify(['ibc/F33B313325B1C99B646B1B786F1EA621E3794D787B90C204C30FE1D4D45970AE', 'factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk'])];

function isPairVisible(denoms) {
  return !hiddenPairs.includes(JSON.stringify(denoms));
}

function isSupportedDenomForDcaPlus(denom) {
  return denom.enabledInDcaPlus && (0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_1__/* .isDenomVolatile */ .g1)(denom);
}
function orderAlphabetically(denoms) {
  return denoms.sort(function (a, b) {
    var nameA = a.name;
    var nameB = b.name;
    return nameA.localeCompare(nameB);
  });
}
function uniqueQuoteDenoms(pairs) {
  return Array.from(new Set(pairs === null || pairs === void 0 ? void 0 : pairs.map(getQuoteDenom)));
}
function uniqueBaseDenoms(pairs) {
  return Array.from(new Set(pairs === null || pairs === void 0 ? void 0 : pairs.map(getBaseDenom)));
}
function uniqueBaseDenomsFromQuoteDenom(initialDenom, pairs) {
  return Array.from(new Set((0,rambda__WEBPACK_IMPORTED_MODULE_8__/* .filter */ .hX)(function (pair) {
    return (0,_utils_pair__WEBPACK_IMPORTED_MODULE_9__/* .getQuoteDenom */ .v)(pair).id === initialDenom.id;
  }, pairs !== null && pairs !== void 0 ? pairs : []).map(_utils_pair__WEBPACK_IMPORTED_MODULE_9__/* .getBaseDenom */ .m)));
}
function uniqueQuoteDenomsFromBaseDenom(resultingDenom, pairs) {
  return Array.from(new Set((0,rambda__WEBPACK_IMPORTED_MODULE_8__/* .filter */ .hX)(function (pair) {
    return (0,_utils_pair__WEBPACK_IMPORTED_MODULE_9__/* .getBaseDenom */ .m)(pair).id === resultingDenom.id;
  }, pairs !== null && pairs !== void 0 ? pairs : []).map(_utils_pair__WEBPACK_IMPORTED_MODULE_9__/* .getQuoteDenom */ .v)));
}
function allDenomsFromPairs(pairs) {
  return Array.from(new Set(pairs === null || pairs === void 0 ? void 0 : pairs.map(function (pair) {
    return getQuoteDenom(pair);
  }).concat(pairs === null || pairs === void 0 ? void 0 : pairs.map(getBaseDenom))));
}
function getResultingDenoms(pairs, initialDenom) {
  return !initialDenom ? [] : orderAlphabetically(Array.from(new Set([].concat((0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(uniqueQuoteDenomsFromBaseDenom(initialDenom, pairs)), (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(uniqueBaseDenomsFromQuoteDenom(initialDenom, pairs))))));
}
function usePairs(injectedChainId, initialDenomId) {
  var _useChainId = (0,_hooks_useChainId__WEBPACK_IMPORTED_MODULE_3__/* .useChainId */ .x)(),
      currentChainId = _useChainId.chainId;

  var chainId = injectedChainId !== null && injectedChainId !== void 0 ? injectedChainId : currentChainId;

  var _useCosmWasmClient = (0,_hooks_useCosmWasmClient__WEBPACK_IMPORTED_MODULE_4__/* .useCosmWasmClient */ .h)(chainId),
      cosmWasmClient = _useCosmWasmClient.cosmWasmClient;

  var _useDenoms = (0,_hooks_useDenoms__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)([chainId]),
      denoms = _useDenoms.denoms;

  var chainClient = (0,_hooks_useChainClient__WEBPACK_IMPORTED_MODULE_6__/* .useChainClient */ .Y)(chainId);
  var supportsLazyPairs = !!(chainClient !== null && chainClient !== void 0 && chainClient.fetchPairsForDenom);

  var _useQuery = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__/* .useQuery */ .a)(['pairs', chainId, supportsLazyPairs ? initialDenomId : 'all'], function () {
    return supportsLazyPairs ? initialDenomId ? chainClient.fetchPairsForDenom(initialDenomId) : Promise.resolve([]) : chainClient.fetchPairs(chainId, (0,_helpers_chains__WEBPACK_IMPORTED_MODULE_2__/* .getDCAContractAddress */ .cr)(chainId), cosmWasmClient);
  }, {
    enabled: !!chainId && !!cosmWasmClient && !!chainClient,
    staleTime: 1000 * 60 * 30,
    meta: {
      errorMessage: 'Error fetching pairs'
    }
  }),
      pairs = _useQuery.data,
      other = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_useQuery, _excluded);

  var hydratedPairs = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function () {
    var denomsById = denoms === null || denoms === void 0 ? void 0 : denoms[chainId];
    if (!denomsById || !pairs) return undefined;
    return pairs.filter(function (pair) {
      return isPairVisible(pair.denoms) && pair.denoms.every(function (denomId) {
        return !!denomsById[denomId];
      });
    }).map(function (pair) {
      return {
        denoms: pair.denoms.map(function (denomId) {
          return denomsById[denomId];
        })
      };
    });
  }, [chainId, denoms, pairs]);
  return _objectSpread({
    pairs: hydratedPairs
  }, other);
}

/***/ }),

/***/ 61456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67848);
/* harmony import */ var _hooks_useChainId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12680);
/* harmony import */ var _hooks_useChainClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74371);
/* harmony import */ var _hooks_useDenoms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(466);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var useRoute = function useRoute(swapAmount, targetDenom) {
  var _useChainId = (0,_hooks_useChainId__WEBPACK_IMPORTED_MODULE_1__/* .useChainId */ .x)(),
      chainId = _useChainId.chainId;

  var chainClient = (0,_hooks_useChainClient__WEBPACK_IMPORTED_MODULE_2__/* .useChainClient */ .Y)(chainId);

  var _useDenoms = (0,_hooks_useDenoms__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)([chainId]),
      getDenomById = _useDenoms.getDenomById;

  var result = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(['prices', 'route', chainId, swapAmount === null || swapAmount === void 0 ? void 0 : swapAmount.denom, swapAmount === null || swapAmount === void 0 ? void 0 : swapAmount.amount, targetDenom === null || targetDenom === void 0 ? void 0 : targetDenom.id], function () {
    return chainClient.fetchRoute(getDenomById(swapAmount.denom), targetDenom, BigInt(swapAmount.amount));
  }, {
    enabled: !!chainId && !!chainClient && !!swapAmount && !!getDenomById(swapAmount.denom) && !!(targetDenom !== null && targetDenom !== void 0 && targetDenom.name),
    staleTime: 1000 * 60,
    retry: false,
    meta: {
      errorMessage: 'Error fetching route'
    }
  });
  return _objectSpread(_objectSpread({}, result), result.data);
};

/* harmony default export */ __webpack_exports__["Z"] = (useRoute);

/***/ }),

/***/ 62235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74231);
/* harmony import */ var _hooks_useChainId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12680);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function getErrorName(error) {
  if (error instanceof Error) return error.name;
  return String(error);
}

var useValidation = function useValidation(validationSchema) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useChainId = (0,_hooks_useChainId__WEBPACK_IMPORTED_MODULE_3__/* .useChainId */ .x)(),
      chainId = _useChainId.chainId;

  var validate = function validate(values) {
    try {
      validationSchema.validateSync(values, {
        abortEarly: false,
        context: _objectSpread({
          chain: chainId
        }, context)
      });
    } catch (error) {
      if (getErrorName(error) !== 'ValidationError') {
        throw error;
      }

      if (error instanceof yup__WEBPACK_IMPORTED_MODULE_2__/* .ValidationError */ .p8) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return error.inner.reduce(function (errors, currentError) {
          // eslint-disable-next-line no-param-reassign
          errors = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.set)(errors, currentError.path, currentError.message);
          return errors;
        }, {});
      }
    }

    return {};
  };

  return {
    validate: validate
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useValidation);

/***/ }),

/***/ 17987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getBaseDenom; },
/* harmony export */   "v": function() { return /* binding */ getQuoteDenom; }
/* harmony export */ });
var getBaseDenom = function getBaseDenom(pair) {
  return pair.denoms[0];
};
var getQuoteDenom = function getQuoteDenom(pair) {
  return pair.denoms[1];
};

/***/ })

}]);